import React from 'react'
import { PageTopContainer } from 'pages/utils'
import { ViewerInfoLine } from 'components'
import { observer } from 'mobx-react-lite'
import { VIEWERS_STORE } from 'store'
import { inject } from 'mobx-react'
import { Props } from './types'

const ViewerDetailsComponent = (props: Props) => {
  const {
    [VIEWERS_STORE]: { currentViewer }
  } = props

  return (
    <PageTopContainer preset='white'>
      <ViewerInfoLine
        viewer={currentViewer}
        singleLine
      />
    </PageTopContainer>
  )
}

const ViewerDetails = inject(VIEWERS_STORE)(observer(ViewerDetailsComponent))
export { ViewerDetails }
